<template>
  <QueueItem @handle-click="launchModal">
    <QueueItemDetail :item="item" class="queue-item__detail--notes grid__col--6">
      <div class="queue-detail queue-detail__title queue-detail__title--fuel-color">{{ item.title }}</div>
      <div class="queue-detail queue-detail__text queue-detail__text--small" v-html="item.description"></div>
    </QueueItemDetail>
    <QueueItemDetail :item="item" class="grid__col--3 queue-item__detail--notes queue-item__detail--no-horiz-padding">
      <People :item="item"></People>
      <FileAttachment v-for="(file, index) in agendaFiles" :key="index" :file="file"></FileAttachment>
      <CommentCount :item="item"></CommentCount>
    </QueueItemDetail>
    <QueueItemDetail :item="item" class="queue-item__detail--notes grid__col--3">
      <div class="queue-detail queue-detail__text grid" v-if="item.note">
        <div class="grid__col--1 h-no-padding h-center-align">
          <i class="fas fa-sticky-note"></i>
        </div>
        <div class="grid__col--11 h-no-margin h-no-padding">
          <div class="item-header__note-text" v-html="item.note"></div>
        </div>
      </div>
    </QueueItemDetail>
  </QueueItem>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import QueueItem from './QueueItem.vue';
  import QueueItemDetail from './QueueItemDetail.vue';
  import FileAttachment from './FileAttachment.vue';
  import People from './People.vue';
  import CommentCount from './CommentCount.vue';

  export default {
    name: 'GenericItem',
    components: {
      QueueItem,
      QueueItemDetail,
      FileAttachment,
      People,
      CommentCount,
    },
    props: ['item', 'index'],
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgenda']),
      contacts() {
        if (this.item.hasOwnProperty('contactIDs')) {
          return lodash.filter(this.currentAgenda.contacts, contact => this.item.contactIDs.includes(contact.id));
        }
        return [];
      },
      users() {
        if (this.item.hasOwnProperty('fuelUserIDs')) {
          return lodash.filter(this.currentAgenda.users, user => this.item.fuelUserIDs.includes(user.id));
        }
        return [];
      },
      agendaFiles() {
        return this.item.hasOwnProperty('agendaFiles') ? this.item.agendaFiles : [];
      },
    },
    methods: {
      launchModal() {
        this.$store.dispatch('meetingAgendas/activateModal', this.index);
      },
    },
  };
</script>
